import React, { Suspense } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import MainContent from './components/content'
import Header from './containers/header'
//import Home from './hour-reports'
import Employees from './containers/employees'
import Customers from './containers/customers'
import { Login } from 'components/login'
import './style.scss'
import { ResetPasswordScreen } from './components/reset-password-screen'
import EmployeeReporting from './containers/employee-reporting'
import { useCurrentUser } from 'context/current-user'

const App = () => {
  const { login, currentUser, loading } = useCurrentUser()

  if (currentUser && !loading) {
    return (
      <BrowserRouter>
        <MainContent
          fullAbsolute={true}
          toolbarClassName="c-app-toolbar"
          toolbarLeftStyle={{ background: '#e4322b;' }}
          toolbarDisablePadding={true}
          contentScroll={false}
          contentTheme={'grey-dark'}
          toolbarStyle={{ paddingLeft: '1em' }}
          contentDisablePadding={true}
          toolbarLeft={<Header />}
          loading={false}
          content={
            <Suspense fallback={<div></div>}>
              <Switch>
                <Route path="/employees" component={(props: any) => <Employees />} />

                <Route path="/customers" component={(props: any) => <Customers />} />
                <Route path="/employee-reporting" component={(props: any) => <EmployeeReporting />} />
                <Route exact path="/">
                  {currentUser.roles.includes('Admin') ? (
                    <Redirect to={`/customers`} />
                  ) : (
                    <Redirect to={`/employee-reporting?employeeId=${currentUser._id}`} />
                  )}
                </Route>
              </Switch>
            </Suspense>
          }
        />
      </BrowserRouter>
    )
  } else if (!currentUser && !loading) {
    return (
      <BrowserRouter>
        <Route path="/">
          <Login
            type={'email'}
            loginAttempt={async (credentials) => {
              login(credentials)
            }}
            logoUrl={'/aputeam.png'}
            backgroundUrl={'/aputeam-background.jpeg'}
          />
        </Route>
        <Route path="/resetPassword/:token">
          <ResetPasswordScreen logoUrl={'/aputeam.png'} backgroundUrl={'/aputeam-background.jpeg'} />
        </Route>
      </BrowserRouter>
    )
  } else {
    return <></>
  }
}

export default App
